export const ELEMENT_IDS = {
  ACTION: 'video_media_action',
  ERROR: 'video_stream_error',
};
